export class PagedDataSource {
  dataSource = Array<any>();
  currentPage: number;
  currentPageSize: number;

  constructor() {}
}
